var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: `${!_vm.dialogType ? "确认" : "拒绝"}`,
        visible: _vm.dialogVisible,
        width: "680px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _vm.dialogType
            ? _c(
                "el-form-item",
                { attrs: { prop: "reason", label: "拒绝原因" } },
                [
                  _c("base-select-common", {
                    ref: "BaseSelectCommon",
                    attrs: { width: "320px", type: 3, title: "拒绝原因" },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reason", $$v)
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.mblIds.length === 1
            ? _c("el-form-item", { attrs: { label: "提单信息" } }, [
                _c(
                  "div",
                  { staticClass: "des" },
                  [
                    _c("el-row", { staticClass: "row" }, [
                      _c("p", [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("提单号"),
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm.billData.mblNo)),
                        ]),
                      ]),
                      _c("p", [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("提单类型"),
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(
                            _vm._s(
                              _vm.billData.classification ? "分单" : "直单"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c("el-row", { staticClass: "row" }, [
                      _c("p", [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("提单件数"),
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm.billData.qty)),
                        ]),
                      ]),
                      _c("p", [
                        _c("span", { staticClass: "label" }, [_vm._v("重量")]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm.billData.weightKgs) + " KG"),
                        ]),
                      ]),
                    ]),
                    _c("el-row", { staticClass: "row" }, [
                      _c("p", [
                        _c("span", { staticClass: "label" }, [_vm._v("方数")]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm.billData.weightCbm)),
                        ]),
                      ]),
                      _c("p", [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("业务范畴"),
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _c("span", { staticClass: "tips clearenceType" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatterClearenceType")(
                                    _vm.billData.clearenceType
                                  )
                                )
                            ),
                          ]),
                          _c("span", { staticClass: "tips pickUpType" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatterPickUpType")(
                                  _vm.billData.pickUpType
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "el-row",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { label: "卸货港", prop: "dischargeHarbor" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "270px" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.dischargeHarbor,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "dischargeHarbor", $$v)
                        },
                        expression: "form.dischargeHarbor",
                      },
                    },
                    _vm._l(_vm.dischargeHarborOptions, function (item, $index) {
                      return _c("el-option", {
                        key: $index,
                        attrs: { label: item.label, value: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { label: "卸货港日期", prop: "dischargeHarborDate" },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "270px" },
                    attrs: {
                      clearable: "",
                      type: "datetime",
                      placeholder: "请选择到卸货港日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.form.dischargeHarborDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dischargeHarborDate", $$v)
                      },
                      expression: "form.dischargeHarborDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "操作", prop: "operator" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "270px" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.operator,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "operator", $$v)
                        },
                        expression: "form.operator",
                      },
                    },
                    _vm._l(_vm.operatorOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.nameCH, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客服", prop: "customer" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "270px" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.customer,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "customer", $$v)
                        },
                        expression: "form.customer",
                      },
                    },
                    _vm._l(_vm.customerOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.nameCH, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "财务", prop: "financer" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "270px" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.financer,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "financer", $$v)
                        },
                        expression: "form.financer",
                      },
                    },
                    _vm._l(_vm.financerOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.nameCH, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.dialogType
            ? _c(
                "el-row",
                { staticClass: "row" },
                [
                  _vm.mblIds.length !== 1 || _vm.billData.clearenceType
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: {
                            prop: "clearanceMode",
                            label: "选择清关模式",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "270px" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择清关模式",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.form.supplierClearenceId = ""
                                },
                              },
                              model: {
                                value: _vm.form.clearanceMode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "clearanceMode", $$v)
                                },
                                expression: "form.clearanceMode",
                              },
                            },
                            _vm._l(
                              _vm.config.clearanceModesOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.mblIds.length !== 1 || _vm.billData.clearenceType) &&
                  _vm.form.clearanceMode !== 2
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: {
                            prop: "invoiceReviewType",
                            label: "选择发票处理方式",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "270px" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择发票处理方式",
                              },
                              model: {
                                value: _vm.form.invoiceReviewType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "invoiceReviewType", $$v)
                                },
                                expression: "form.invoiceReviewType",
                              },
                            },
                            _vm._l(
                              _vm.config.invoiceReviewTypeOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.mblIds.length !== 1 || _vm.billData.clearenceType) &&
                  _vm.form.clearanceMode !== 2 &&
                  _vm.form.invoiceReviewType === 1
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { prop: "tax", label: "税金范围" },
                        },
                        [
                          _c("number-range", {
                            staticStyle: { width: "270px" },
                            attrs: { min: 0.01, precision: 2, max: 990000 },
                            model: {
                              value: _vm.form.tax,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tax", $$v)
                              },
                              expression: "form.tax",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.mblIds.length !== 1 || _vm.billData.clearenceType
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: {
                            prop: "supplierClearenceId",
                            label: "选择清关行",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "270px" },
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.supplierClearenceId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "supplierClearenceId", $$v)
                                },
                                expression: "form.supplierClearenceId",
                              },
                            },
                            _vm._l(_vm.clearenceOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.clearanceMode === 2
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { prop: "entryModel", label: "选择生成模式" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "270px" },
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.entryModel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "entryModel", $$v)
                                },
                                expression: "form.entryModel",
                              },
                            },
                            _vm._l(_vm.entryModelOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.billData.pickUpType
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { prop: "supplierId", label: "选择提货车行" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "270px" },
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "supplierId", $$v)
                                },
                                expression: "form.supplierId",
                              },
                            },
                            _vm._l(_vm.pickUpOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.billData.pickUpType === 2
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: {
                            prop: "supplierUnstuffingId",
                            label: "拆柜供应商",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "270px" },
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.supplierUnstuffingId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "supplierUnstuffingId",
                                    $$v
                                  )
                                },
                                expression: "form.supplierUnstuffingId",
                              },
                            },
                            _vm._l(_vm.unstuffingOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.supplierClearenceId
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "isSkipForecastReview", label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.form.isSkipForecastReview,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "isSkipForecastReview",
                                    $$v
                                  )
                                },
                                expression: "form.isSkipForecastReview",
                              },
                            },
                            [
                              _vm._v("跳过预报审核"),
                              _c("br"),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("(提单状态将跳转至预报已接受)")]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.form.clearanceMode === 2
            ? _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { label: "T11预报" },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            action: "#",
                            "show-file-list": false,
                            "http-request": _vm.httpRequest,
                          },
                        },
                        [
                          _c("div", { staticClass: "upload" }, [
                            !_vm.file.name
                              ? _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/bill/upload-1.png"),
                                    alt: "",
                                  },
                                })
                              : _c("i", {
                                  staticClass: "el-icon-circle-check",
                                }),
                            _vm._v(" 选择文件上传 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }